"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ALGORITHM = 'RSA-OAEP';
function generateKeyPair() {
    if (!window.crypto || !window.crypto.subtle) {
        return Promise.reject(new Error('crypto.subtle not available'));
    }
    var options = {
        name: ALGORITHM,
        modulusLength: 2048,
        publicExponent: new Uint8Array([1, 0, 1]),
        hash: { name: 'SHA-256' }
    };
    return window.crypto.subtle
        .generateKey(options, true, ['encrypt', 'decrypt', 'unwrapKey'])
        .then(function (keypair) {
        return Promise.all([
            window.crypto.subtle.exportKey('spki', keypair.publicKey),
            window.crypto.subtle.exportKey('jwk', keypair.privateKey)
        ]);
    })
        .then(function (keypair) { return ({
        publicKey: window.btoa(arrayBufferToString(keypair[0])),
        privateKey: keypair[1]
    }); });
}
exports.generateKeyPair = generateKeyPair;
function decryptPayload(privateKey, ciphertext) {
    if (!window.crypto || !window.crypto.subtle) {
        return Promise.reject(new Error('crypto.subtle not available'));
    }
    return window.crypto.subtle
        .importKey('jwk', privateKey, { name: ALGORITHM, hash: { name: 'SHA-256' } }, false, ['decrypt'])
        .then(function (key) {
        return window.crypto.subtle.decrypt({ name: ALGORITHM, hash: { name: 'SHA-256' } }, key, stringToArrayBuffer(window.atob(ciphertext)));
    })
        .then(function (decrypted) {
        return arrayBufferToString(decrypted);
    });
}
exports.decryptPayload = decryptPayload;
function encryptStoreboxCard(storeboxKey, _a) {
    var year = _a.year, month = _a.month, pan = _a.pan;
    if (!window.crypto || !window.crypto.subtle) {
        return Promise.reject(new Error('crypto.subtle not available'));
    }
    return window.crypto.subtle
        .importKey('jwk', storeboxKey, { name: ALGORITHM, hash: { name: 'SHA-1' } }, false, ['encrypt'])
        .then(function (key) {
        var cardInfo = year + " " + month + " " + pan;
        return window.crypto.subtle.encrypt({ name: ALGORITHM, hash: { name: 'SHA-1' } }, key, stringToArrayBuffer(cardInfo));
    })
        .then(function (encrypted) {
        return arrayBufferToString(encrypted);
    });
}
exports.encryptStoreboxCard = encryptStoreboxCard;
function stringToArrayBuffer(str) {
    var buf = new ArrayBuffer(str.length);
    var bufView = new Uint8Array(buf);
    for (var i = 0, strLen = str.length; i < strLen; i++) {
        bufView[i] = str.charCodeAt(i);
    }
    return buf;
}
function arrayBufferToString(str) {
    var byteArray = new Uint8Array(str);
    var byteString = '';
    for (var i = 0; i < byteArray.byteLength; i++) {
        byteString += String.fromCodePoint(byteArray[i]);
    }
    return byteString;
}
//# sourceMappingURL=index.js.map